import React from 'react';
import { Navigation } from '../components/Navigation';
import { FlaskConicalIcon } from 'lucide-react';
export function Pathology() {
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-1857">
      <Navigation data-id="element-1858" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1859">
        <div className="flex items-center space-x-3 mb-6" data-id="element-1860">
          <FlaskConicalIcon className="w-8 h-8 text-red-600" data-id="element-1861" />
          <div data-id="element-1862">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-1863">Pathology Lab</h1>
            <p className="text-gray-600" data-id="element-1864">Lab and blood collection management</p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center" data-id="element-1865">
          <p className="text-gray-500" data-id="element-1866">
            Pathology Lab features will be implemented here
          </p>
        </div>
      </div>
    </div>;
}